import { createClient, type SupabaseClient } from '@supabase/supabase-js'
import { ENV } from './env'

let client: SupabaseClient | null = null

/** Created on first use so mock mode never touches Supabase. */
export function supabase(): SupabaseClient {
  if (!client) client = createClient(ENV.supabaseUrl, ENV.supabaseAnonKey, { auth: { persistSession: true, autoRefreshToken: true, storageKey: 't4-console-auth' } })
  return client
}

export async function getAccessToken(): Promise<string | null> {
  const { data } = await supabase().auth.getSession()
  return data.session?.access_token ?? null
}

type Listener = () => void
const listeners = new Set<Listener>()
/** Called by the API layer when the server answers 401; the auth provider signs out and shows the login page. */
export function onUnauthorized(fn: Listener) { listeners.add(fn); return () => { listeners.delete(fn) } }
export function emitUnauthorized() { for (const l of listeners) l() }
